import styled, {css} from 'styled-components';

import {ReactNode} from 'react';

import {DRILL_DOWN_COLUMN} from '../constants/DRILL_DOWN_COLUMN';
import {DRILL_DOWN_COLUMN_ATTRIBUTE} from '../constants/DRILL_DOWN_COLUMN_ATTRIBUTE';
import {DRILL_DOWN_TARGET_ATTRIBUTE} from '../constants/DRILL_DOWN_TARGET_ATTRIBUTE';

interface DrillDownHoverSurfaceProps {
  children: ReactNode;
  isEnabled: boolean;
}

export function DrillDownHoverSurface(props: DrillDownHoverSurfaceProps) {
  if (!props.isEnabled) {
    return <>{props.children}</>;
  }

  return <HoverSurface>{props.children}</HoverSurface>;
}

const HoverSurface = styled.div(
  ({theme}) => css`
    /* Match the platform Table's tr/td structure. These selectors outrank its stripe and hover
       rules so a focused row stays blue while the column overlay preserves the resting stripe. */
    tr:nth-child(even):not(:has([${DRILL_DOWN_TARGET_ATTRIBUTE}='true'])) td {
      background-color: ${theme.colors.palettes.neutral[20][100]};
    }

    @media (hover: hover) {
      tr:nth-child(even):not(:has([${DRILL_DOWN_TARGET_ATTRIBUTE}='true'])):hover td {
        background-color: ${theme.colors.palettes.blue[20][100]};
      }

      ${Object.values(DRILL_DOWN_COLUMN)
        .map(
          (column) => `
        &:has(td:hover > [${DRILL_DOWN_COLUMN_ATTRIBUTE}='${column}'])
          td:has(> [${DRILL_DOWN_COLUMN_ATTRIBUTE}='${column}']) {
          background-image: linear-gradient(
            color-mix(in srgb, ${theme.colors.palettes.blue[60][100]} 8%, transparent),
            color-mix(in srgb, ${theme.colors.palettes.blue[60][100]} 8%, transparent)
          );
        }

        &:has(td:hover > [${DRILL_DOWN_COLUMN_ATTRIBUTE}='${column}'])
          tr:hover
          td:has(> [${DRILL_DOWN_COLUMN_ATTRIBUTE}='${column}']) {
          background-image: linear-gradient(
            color-mix(in srgb, ${theme.colors.palettes.blue[60][100]} 14%, transparent),
            color-mix(in srgb, ${theme.colors.palettes.blue[60][100]} 14%, transparent)
          );
        }
      `
        )
        .join('')}
    }
  `
);
